import { Button, styled, useTheme } from '@mui/material';
import { Typography } from '../../../components/Typography/Typography';
import { ReactComponent as SyncIcon } from '../../../assets/icons/sync.svg';

interface Props {
  selectedCount: number;
  /** Optional — the Redelegate action is wired in a later phase (shown only when provided). */
  onReassign?: () => void;
  onRemove: () => void;
  onClear: () => void;
}

/** Multi-row action bar shown above the delegations table when one or more rows are selected. */
export const DelegatesBulkActions = ({ selectedCount, onReassign, onRemove, onClear }: Props) => {
  const { colors } = useTheme();

  return (
    <Container>
      <Typography variant='body' color={colors.text.main}>
        {`${selectedCount} delegation${selectedCount === 1 ? '' : 's'} selected`}
      </Typography>
      <ActionBtnsWrap>
        {onReassign && (
          <Button
            variant='contained'
            onClick={onReassign}
            startIcon={<SyncIcon />}
            style={{ backgroundColor: colors.surfaceAccent.default, color: colors.textAccent.inverse }}
            sx={{ svg: { path: { fill: colors.textAccent.inverse } } }}
          >
            Redelegate
          </Button>
        )}
        <Button
          variant='contained'
          onClick={onRemove}
          style={{ backgroundColor: colors.surfaceAccent.default, color: colors.textAccent.inverse }}
        >
          Remove
        </Button>
        <Button
          variant='text'
          onClick={onClear}
          style={{ backgroundColor: 'transparent', color: colors.text.main }}
        >
          Clear Selection
        </Button>
      </ActionBtnsWrap>
    </Container>
  );
};

const Container = styled('div')`
  background: ${({ theme }) => theme.colors.surfaceInteraction.selected};
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`;

const ActionBtnsWrap = styled('div')`
  background: ${({ theme }) => theme.colors.surfaceInteraction.selected};
  border-radius: 4px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
